import type { CSSProperties } from 'react';

// Shared by the Advisors panels and Sales users; inline styles beat the host CMS's
// global `button {}` rule.
const MUTED: CSSProperties = { color: 'var(--text-muted)' };
const PRIMARY_BTN: CSSProperties = {
  background: 'var(--brand-primary)',
  color: 'var(--text-on-brand)',
  border: 'none',
  margin: 0
};
const SECONDARY_BTN: CSSProperties = {
  background: 'var(--surface-card)',
  color: 'var(--text-primary)',
  border: '1px solid var(--border-default)',
  margin: 0
};
const FIELD: CSSProperties = {
  background: 'var(--surface-card)',
  color: 'var(--text-primary)',
  border: '1px solid var(--border-default)',
  borderRadius: 6,
  padding: '6px 10px',
  margin: 0
};
export const SHARED_STYLES = { MUTED, PRIMARY_BTN, SECONDARY_BTN, FIELD };
